import React from 'react';
import './InfoHint.css';

const InfoHint = ({ label, children }) => (
  <button
    type="button"
    className="analytics-info-hint"
    aria-label={`${label}: ${children}`}
  >
    <i className="bi bi-info" aria-hidden />
    <span className="analytics-info-tooltip" role="tooltip">
      {children}
    </span>
  </button>
);

export default InfoHint;
